import { Badge } from "@/components/ui/badge";
import { useLang } from "@/i18n";

export default function StatusBadge({ status }) {
  const { t } = useLang();
  const map = {
    pending: { cls: "bg-amber-50 text-amber-600 border-amber-200", label: t("dash.pendingBadge") },
    executed: { cls: "bg-emerald-50 text-emerald-600 border-emerald-200", label: t("dash.executedBadge") },
    validated: { cls: "bg-emerald-50 text-emerald-600 border-emerald-200", label: t("dash.validatedBadge") },
    active: { cls: "bg-emerald-50 text-emerald-600 border-emerald-200", label: t("dash.validatedBadge") },
    approved: { cls: "bg-emerald-50 text-emerald-600 border-emerald-200", label: t("wallet.approved") },
    rejected: { cls: "bg-red-50 text-red-600 border-red-200", label: t("dash.rejectedBadge") },
  };
  const s = map[status] || map.pending;
  return (
    <Badge variant="outline" className={`${s.cls} text-[11px] font-medium`} data-testid={`status-badge-${status}`}>
      {s.label}
    </Badge>
  );
}
